import { render, staticRenderFns } from "./WithSummaryCitations.vue?vue&type=template&id=1484e156"
import script from "./WithSummaryCitations.vue?vue&type=script&lang=js"
export * from "./WithSummaryCitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports